module.exports = __webpack_public_path__ + "static/14-2fdde45fe76a937cf1d6512f6d9172b8.gif";